
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.004.022A5.915 5.915 0 003.1 5.925v7.994H.79a.77.77 0 00-.77.77.77.77 0 00.77.77h4.465c.35 1.443 1.648 2.528 3.194 2.528h1.107c1.546 0 2.844-1.085 3.194-2.528h4.466a.77.77 0 00.77-.77.77.77 0 00-.77-.77h-2.31V5.925A5.915 5.915 0 009.004.022zm0 1.54a4.352 4.352 0 014.363 4.363v7.994H4.64V5.925a4.352 4.352 0 014.363-4.363zM7.01 15.46h3.986c-.294.552-.763.986-1.44.986H8.45c-.676 0-1.145-.434-1.44-.986z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    